import React from 'react';
import { Link } from 'react-router-dom';

export const parseMarkdownLinks = (text: string): React.ReactNode => {
  if (!text) return text;

  const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;

  while ((match = markdownLinkRegex.exec(text)) !== null) {
    const [fullMatch, linkText, url] = match;
    const matchIndex = match.index;

    if (matchIndex > lastIndex) {
      parts.push(text.substring(lastIndex, matchIndex));
    }

    if (url.startsWith('/')) {
      parts.push(
        <Link 
          key={matchIndex} 
          to={url}
          style={{ color: '#1890ff', textDecoration: 'underline' }}
        >
          {linkText}
        </Link>
      );
    } else {
      parts.push(
        <a 
          key={matchIndex} 
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1890ff', textDecoration: 'underline' }}
        >
          {linkText}
        </a>
      );
    }

    lastIndex = matchIndex + fullMatch.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  if (parts.length === 0) {
    return text;
  }

  return <>{parts}</>;
};
